import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { requireGuest } from '@/lib/router/route-guards';

const searchSchema = z.object({
  invite: z.string().optional(),
  redirect: z.string().optional(),
});

export const Route = createFileRoute('/_app/signup')({
  validateSearch: searchSchema,
  beforeLoad: ({ context }) => {
    requireGuest(context);
  },
});
